import { Link, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { DEPARTMENT_LABEL, TICKET_DEPARTMENTS, ticketDepartment, type WorkspaceConfig } from '@atlas/contracts';
import { api } from '../../lib/api';

export type WorkspaceProject = { id: string; name: string; canConfigure: boolean; workflows: WorkspaceConfig[] };
export function useWorkspaceProjects() {
  return useQuery({ queryKey: ['workspace-projects'], queryFn: () => api.get<{ projects: WorkspaceProject[] }>('/v2/workspaces') });
}
export function WorkspaceSwitcher() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const department = ticketDepartment(params.get('department'));
  const mode = params.get('mode') === 'board' ? '&mode=board' : '';
  const group = params.has('group') ? `&group=${encodeURIComponent(params.get('group')!)}` : '';
  return <nav aria-label="Ticket departments" className="flex flex-wrap gap-1 px-6 py-2 border-b border-border bg-surface">
    {TICKET_DEPARTMENTS.map(kind => <Link key={kind} to={`/tickets?department=${kind}${mode}${group}`}
      aria-current={location.pathname === '/tickets' && department === kind ? 'page' : undefined}
      className={`px-4 py-2 rounded-lg text-sm font-semibold ${location.pathname === '/tickets' && department === kind ? 'bg-brand text-brand-ink' : 'text-muted hover:bg-surface2'}`}>
      {DEPARTMENT_LABEL[kind]}</Link>)}
  </nav>;
}
